import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmHeading } from '@/components/uiParts';
import { Form } from '@/pages/login/components/Form';
import { HeroLogo } from '@/pages/login/components/HeroLogo';
import { routes } from '@/router';

import { useSignin } from './hooks/useSignin';

const LoginPage = (): JSX.Element => {
  const signin = useSignin();

  return (
    <LoginLayout>
      <HeroLogo />
      <LoginCard>
        <CmHeading fontSize="2xl" mb={5} as="h1">
          {routes.Login.title}
        </CmHeading>
        <Form onSubmit={signin} />
      </LoginCard>
    </LoginLayout>
  );
};

export default LoginPage;
